import styled from 'styled-components';
import { Text } from '@cmctechnology/phoenix-stockbroking-web-design';

export const SubText = styled(Text)`
  width: 70%;
`;
